import {SupportTicketSingleDto} from "../API";
import {AppRoute} from "../AppRoutes";

export const isCurrentSupportTicketRoute = (pathname: string): boolean =>
    pathname === AppRoute.EDIT_SUPPORT_TICKET();

export const getRouteScopedCurrentTicket = <
    TTicket extends Pick<SupportTicketSingleDto, "id"> | undefined,
>(
    pathname: string,
    currentTicket: TTicket,
): TTicket | undefined =>
    isCurrentSupportTicketRoute(pathname) ? currentTicket : undefined;

export interface CompanyOverviewSupportTicketState {
    supportTicketId?: number;
    supportTicketCompanyId?: number;
}

export const makeCompanyOverviewSupportTicketState = <
    TTicket extends Pick<SupportTicketSingleDto, "id" | "companyId"> | undefined,
>(
    ticket: TTicket,
): CompanyOverviewSupportTicketState | undefined => {
    if (!ticket?.id || !ticket.companyId) {
        return undefined;
    }

    return {
        supportTicketId: ticket.id,
        supportTicketCompanyId: ticket.companyId,
    };
};

export const getCompanyOverviewSupportTicketId = (
    state: unknown,
    companyId?: number,
): number | undefined => {
    const routeState = state as CompanyOverviewSupportTicketState | undefined;

    if (
        !routeState?.supportTicketId ||
        !routeState.supportTicketCompanyId ||
        !companyId
    ) {
        return undefined;
    }

    return routeState.supportTicketCompanyId === companyId
        ? routeState.supportTicketId
        : undefined;
};

export type SupportActivityCandidate = {
    companyId?: number;
    supportTicketId?: number;
};

export const isSupportActivityVisibleForTicket = <
    TTicket extends Pick<SupportTicketSingleDto, "id"> | undefined,
>(
    currentTicket: TTicket,
    activity: SupportActivityCandidate,
): boolean =>
    !currentTicket?.id ||
    !activity.supportTicketId ||
    activity.supportTicketId === currentTicket.id;

export const isSupportActivityRelatedToCurrentTicket = <
    TTicket extends Pick<SupportTicketSingleDto, "id" | "companyId"> | undefined,
>(
    currentTicket: TTicket,
    activity: SupportActivityCandidate,
): boolean =>
    !!(
        currentTicket?.id &&
        (activity.supportTicketId === currentTicket.id ||
            (!activity.supportTicketId &&
                !!currentTicket.companyId &&
                activity.companyId === currentTicket.companyId))
    );

export const supportActivityCandidateLabel = <
    TTicket extends Pick<SupportTicketSingleDto, "id" | "companyId"> | undefined,
>(
    currentTicket: TTicket,
    activity: SupportActivityCandidate,
): string | undefined => {
    if (currentTicket?.id && activity.supportTicketId === currentTicket.id) {
        return "Moguće vezano uz ovaj tiket";
    }

    if (activity.supportTicketId) {
        return `Moguće vezano uz tiket #${activity.supportTicketId}`;
    }

    if (
        currentTicket?.id &&
        currentTicket.companyId &&
        activity.companyId === currentTicket.companyId
    ) {
        return "Moguće vezano uz ovaj tiket (isti klijent)";
    }

    return undefined;
};
